import { observer } from 'mobx-react-lite';
import { weatherEditLocations, moreDetails_0 } from './WeatherCard.locstring.json';
import loc from 'owa-localize';
import { differenceInCalendarDays, DisplayDate, now } from 'owa-datetime';
import * as React from 'react';
import WeatherCardContent from './WeatherCardContent';
import weatherStore from '../store';

import { IconButton } from '@fluentui/react/lib/Button';
import { Link } from '@fluentui/react/lib/Link';
import { updateCurrentLocationIndex } from '../actions/updateCurrentLocationIndex';
import { lazyMountAndShowFullOptions } from 'owa-options-view';

import styles from './WeatherCard.scss';
const prevLabel = 'Back';
const nextLabel = 'Forward';

/**
 * Props for Weather callout content
 */
export interface WeatherCardProps {
    date: DisplayDate;
}

/**
 * Component for rendering weather callout information in peek
 */
export default observer(function WeatherCard(props: WeatherCardProps) {
    const renderWeather = (daysFromToday: number) => {
        let locationIndex = weatherStore.currentLocationIndex;
        let locations = getNumberOfLocations();
        let currentLocation = weatherStore.weatherLocations?.[locationIndex];

        if (currentLocation) {
            let locationName = currentLocation.locationId?.Name;
            let clickThrough = currentLocation.clickThrough;
            let leftIconProps = {
                iconName: prevLabel,
            };
            let rightIconProps = {
                iconName: nextLabel,
            };
            return (
                <div className={styles.weatherCard}>
                    <div className={styles.weatherCardHeader}>
                        <h3>{locationName}</h3>
                        {locations > 1 && (
                            <nav className={styles.weatherLocationSwitcher}>
                                <IconButton
                                    id={prevLabel}
                                    className={styles.prevButton}
                                    iconProps={leftIconProps}
                                    onClick={changeLocation}
                                    disabled={locationIndex === 0}
                                />
                                <IconButton
                                    id={nextLabel}
                                    className={styles.nextButton}
                                    iconProps={rightIconProps}
                                    onClick={changeLocation}
                                    disabled={locationIndex === locations - 1}
                                />
                            </nav>
                        )}
                    </div>
                    <div className={styles.weatherCardBody}>
                        <WeatherCardContent daysFromToday={daysFromToday} />
                    </div>
                    <div className={styles.weatherCardFooter}>
                        <Link
                            className={styles.weatherEditLocations}
                            onClick={onEditWeatherLocationsClicked}>
                            {loc(weatherEditLocations)}
                        </Link>
                        <Link
                            className={styles.weatherClickThrought}
                            target="_blank"
                            href={String(clickThrough)}>
                            {loc(moreDetails_0)}
                        </Link>
                    </div>
                </div>
            );
        }

        return null;
    };
    const onEditWeatherLocationsClicked = () => {
        lazyMountAndShowFullOptions.importAndExecute('calendar', 'weather');
    };
    const changeLocation = (event: React.MouseEvent<HTMLButtonElement>) => {
        let label = event.currentTarget.id;
        let locDelta = label == prevLabel ? -1 : 1;
        let locationIndex = weatherStore.currentLocationIndex;
        let locationsLength = getNumberOfLocations();
        let updatedLoc = locationIndex + locDelta;
        if (locDelta > 0 && locationIndex == locationsLength - 1) {
            updatedLoc = 0;
        } else if (locDelta < 0 && locationIndex == 0) {
            updatedLoc = locationsLength - 1;
        }
        updateCurrentLocationIndex(weatherStore, updatedLoc);
    };
    let { date } = props;
    let today = now();
    let daysFromToday = differenceInCalendarDays(date, today);
    return renderWeather(daysFromToday);
});

const getNumberOfLocations = () =>
    weatherStore.weatherLocations ? weatherStore.weatherLocations.length : 0;
